import { render, staticRenderFns } from "./Timer.vue?vue&type=template&id=1f85bd4e&scoped=true&"
import script from "./Timer.vue?vue&type=script&lang=js&"
export * from "./Timer.vue?vue&type=script&lang=js&"
import style0 from "./Timer.vue?vue&type=style&index=0&id=1f85bd4e&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f85bd4e",
  null
  
)

export default component.exports